import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  Button,
  TextField,
  IconButton,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Grid,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Modal,
  Select,
  InputLabel,
  FormControl,
  Tabs,
  Tab,
  Card,
  CardContent,
  Divider,
  CardActions,
  Rating,
  TablePagination,
} from "@mui/material";
import {
  validateName,
  validateShopName,
  validateEmail,
  validatePhoneNumber,
  validateDropdown,
  validateDropdownForArray,
  validateDOB,
  validateAadhar,
  validatePAN,
  validateGST,
  validateCountry,
  validateState,
  validateCity,
  validateStreet,
  validateLandmark,
  validatePincode,
} from "../../utils/textFieldValidations";
import { Delete, UploadFile } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import StarIcon from "@mui/icons-material/Star";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Notifications } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import AppHeaderBar from "../../components/AppBar/appBar";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import * as XLSX from "xlsx";
import {
  convertDate,
  convertYearMonthDateToMonthDateYear,
  convertDateToDateMonthYear,
} from "../../utils/DateFormats";
import {
  GoogleMap,
  useLoadScript,
  MarkerF,
  InfoWindowF,
} from "@react-google-maps/api";

const AdminCustomerManagement = ({ onBackScreenName }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null); // Reference to the Marker
  const [errorMessage, setErrorMessage] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isInfoWindowOpen, setInfoWindowOpen] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [moduleStatusData, setModuleStatusData] = useState({});
  const [data, setData] = useState("");
  const [errors, setErrors] = useState({});
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [openPencilModal, setOpenPencilModal] = useState(false);
  const [isEditMode, setEditMode] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [editData, setEditData] = useState({ imageUrl: "" });
  const [anchorEl, setAnchorEl] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [dob, setDob] = useState(new Date());
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [filter, setFilter] = useState("All"); // Default dropdown value
  const [ordersTableData, setOrdersTableData] = useState([]);
  const [customerRatings, setCustomerRatings] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [orderPage, setOrderPage] = useState(0);
  const [orderRowsPerPage, setOrderRowsPerPage] = useState(10);
  const [id, setId] = useState(13); //For Customer Mangement id is 13
  const statusURL = BASE_URL_TEST + urls("getStatusById", id);
  const [ratingsPage, setRatingsPage] = useState(0);
  const [ratingsRowsPerPage, setRatingsRowsPerPage] = useState(10);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const [feedbacks, setFeedbacks] = useState([
    {
      id: 1,
      date: "2024-11-28",
      brand: "Brand name",
      color: "color",
      message: "Great service! Very satisfied with my purchase.",
      imageUrl: "path/to/image1.jpg",
      response:
        "Thank you for your kind words, Alice! We're glad you're satisfied.",
      approved: false,
      rating: 4,
    },
    {
      id: 2,
      date: "2023-05-10",
      brand: "Brand name",
      color: "color",
      message:
        "Thank you for your kind words, Alice! We're glad you're satisfied.",
      imageUrl: "path/to/image2.jpg",
      response:
        "Thank you for your kind words, Alice! We're glad you're satisfied.",
      approved: true,
      rating: 5,
    },
  ]);

  const [sortOption, setSortOption] = useState("");
  const [customerData, setCustomerData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    location: "",
    dob: "",
    profilePhoto: "",
    country: "",
    state: "",
    city: "",
    street: "",
    landmark: "",
    pincode: "",
    latitude: "",
    longitude: "",
    status: "",
    searchlocation: "",
    id: "",
  });
  const initializeCustomers = () => {
    setCustomerData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      location: "",
      dob: "",
      profilePhoto: "",
      country: "",
      state: "",
      city: "",
      street: "",
      landmark: "",
      pincode: "",
      latitude: customerData?.latitude,
      longitude: customerData?.longitude,
      status: "",
      searchlocation: "",
    });
  };
  const [customerviewData, setCustomerviewData] = useState({
    customerId: "",
    name: "",
    email: "",
    phoneNumber: "",
    status: "",
    dob: "",
  });
  const loginToken = useSelector((state) => state.user.logintoken);

  const useGoogleMaps = () => {
    const { isLoaded, loadError } = useLoadScript({
      googleMapsApiKey: "AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8",
      libraries: ["places"],
    });

    return { isLoaded, loadError };
  };
  const { isLoaded, loadError } = useGoogleMaps();

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setCustomerData((customerData) => ({
          ...customerData,
          latitude: latitude,
          longitude: longitude,
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, [latitude, longitude]);

  // Function to handle location search using Google Maps Geocoding API
  const handleLocationSearch = async (e) => {
    const searchValue = e.target.value;
    setCustomerData({
      ...customerData,
      searchlocation: searchValue,
    });

    const query = `${customerData["country"]}, ${customerData["state"]}, ${searchValue}`;
    console.log("query", query);

    if (searchValue) {
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            query,
          )}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
        );

        const data = await response.json();

        if (data.results && data.results.length > 0) {
          const { lat, lng } = data.results[0].geometry.location;
          const newLocation = data.results[0].formatted_address;

          // Update customer data with latitude, longitude, and location
          setCustomerData((prevData) => ({
            ...prevData,
            latitude: lat,
            longitude: lng,
          }));

          if (mapRef.current) {
            mapRef.current.setCenter({ lat, lng });
            mapRef.current.setZoom(15);
          }
          if (markerRef.current) {
            markerRef.current.setPosition({ lat, lng });
          }
        } else {
          console.log("No results found.");
        }
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    }
  };
  //get All Customers data
  useEffect(() => {
    fetchData();
    fetchCustomerStatus();
  }, []);

  //get All Customers data
  const {
    data: customersData,
    isLoading: isCutomersDataLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllCustomers"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  //get status data
  const {
    data: allStatusData,
    isLoading: isStatusLoading,
    error: statusError,
    fetchData: fetchCustomerStatus,
  } = useFetch(statusURL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: createCustomersData,
    isLoading: createCustomersLoading,
    error: createCustomersError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createCustomer"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateCustomersData,
    isLoading: updateCustomersLoading,
    error: updateCustomersError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deleteCustomersData,
    isLoading: deleteCustomersLoading,
    error: deleteCustomersError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (error) {
    } else if (customersData && customersData["status"] === true) {
      setData(customersData["data"]);
    }
  }, [customersData, error]);

  //getstatus useEffect
  useEffect(() => {
    if (statusError) {
    } else if (allStatusData && allStatusData["status"] === true) {
      setModuleStatusData(allStatusData["data"]);
    }
  }, [allStatusData, statusError]);

  //Create Customer
  useEffect(() => {
    if (createCustomersError) {
    } else if (createCustomersData && createCustomersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: createCustomersData["message"],
        status: createCustomersData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (createCustomersData && createCustomersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createCustomersData["message"],
        status: createCustomersData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createCustomersData, createCustomersError]);

  //Update Customer
  useEffect(() => {
    if (updateCustomersError) {
    } else if (updateCustomersData && updateCustomersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateCustomersData["message"],
        status: updateCustomersData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (updateCustomersData && updateCustomersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateCustomersData["message"],
        status: updateCustomersData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateCustomersData, updateCustomersError]);

  //Delete Customer
  useEffect(() => {
    if (deleteCustomersError) {
    } else if (deleteCustomersData && deleteCustomersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteCustomersData["message"],
        status: deleteCustomersData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    } else if (deleteCustomersData && deleteCustomersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteCustomersData["message"],
        status: deleteCustomersData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    }
  }, [deleteCustomersData, deleteCustomersError]);

  const clearErrors = () => {
    setErrors({});
  };
  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  // Filter data based on search
  const filteredData =
    data && data.length > 0
      ? data
          .sort((a, b) => b.id - a.id) // Sort by ID in descending order, latest ID first
          .filter(
            (item) =>
              (item.id &&
                item.id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.first_name &&
                item.first_name.toLowerCase().includes(search.toLowerCase())) ||
              (item.location &&
                item.location.toLowerCase().includes(search.toLowerCase())) ||
              (item.email &&
                item.email.toLowerCase().includes(search.toLowerCase())) ||
              (item.phone_number &&
                item.phone_number.toString().includes(search.toLowerCase())) ||
              (item.status &&
                item.status.toLowerCase().includes(search.toLowerCase())),
          )
      : data;

  const handleAdd = () => {
    setEditMode(false);
    initializeCustomers();
    clearErrors();
    setOpen(true);
  };

  const handleSubmit = () => {
  let validationErrors = {};

  if (!customerData.phoneNumber || !validatePhoneNumber(customerData.phoneNumber)) {
    validationErrors.phoneNumber = "Please enter a 10 digit phone number.";
    setErrors(validationErrors);
    return;
  }
  if (!customerData.location || !validateCity(customerData.location)) {
    validationErrors.location = "Location is required and should only contain letters and spaces.";
    setErrors(validationErrors);
    return;
  }
  if (!customerData.country || !validateCountry(customerData.country)) {
    validationErrors.country = "Country is required and should only contain letters and spaces.";
    setErrors(validationErrors);
    return;
  }
  if (!customerData.state || !validateState(customerData.state)) {
    validationErrors.state = "State is required and should only contain letters and spaces.";
    setErrors(validationErrors);
    return;
  }
  if (!customerData.street || !validateStreet(customerData.street)) {
    validationErrors.street = "Street is required.";
    setErrors(validationErrors);
    return;
  }
  if (!customerData.landmark || !validateLandmark(customerData.landmark)) {
    validationErrors.landmark = "Landmark is required.";
    setErrors(validationErrors);
    return;
  }
  if (!customerData.pincode || !validatePincode(customerData.pincode)) {
    validationErrors.pincode = "Pincode should be a 6-digit number.";
    setErrors(validationErrors);
    return;
  }
  if (!customerData.searchlocation || !validateLandmark(customerData.searchlocation)) {
    validationErrors.searchlocation = "Location is required.";
    setErrors(validationErrors);
    return;
  }
  if (!validateDropdownForArray(customerData.status)) {
    validationErrors.statusDropdown = "Please select status.";
    setErrors(validationErrors);
    return;
  }

  clearErrors();

  const formdata = new FormData();
  formdata.append("first_name", customerData["firstName"]);
  formdata.append("last_name", customerData["lastName"]);
  formdata.append("location", customerData["location"]);
  formdata.append("email", customerData["email"]);
  formdata.append("phone_number", customerData["phoneNumber"]);
  formdata.append("status", customerData["status"]);
  formdata.append("dob", customerData.dob ? convertDateToDateMonthYear(customerData.dob) : null);
  formdata.append("country", customerData["country"]);
  formdata.append("state", customerData["state"]);
  formdata.append("city", customerData["location"]);   // ✅ city = location
  formdata.append("street", customerData["street"]);
  formdata.append("landmark", customerData["landmark"]);
  formdata.append("pincode", customerData["pincode"]);
  formdata.append("latitude", customerData["latitude"]);
  formdata.append("longitude", customerData["longitude"]);
  formdata.append("profile", selectedFile ? selectedFile : customerData["profilePhoto"]);

 if (isEditMode) {
  console.log("Customer ID:", customerData["id"]);
  console.log("Login Token:", loginToken);
  console.log("Update URL:", urls("updateCustomer", customerData["id"]));

  // Log all formdata entries
  for (let [key, value] of formdata.entries()) {
    console.log(`${key}: ${value}`);
  }

  // const updateUrl = urls("updateCustomer", customerData["id"]);
  // fetchUpdateData(updateUrl, formdata);
   const updateUrl =  urls("updateCustomer", customerData["id"]);
fetchUpdateData(updateUrl, formdata);
} else {
    fetchCreateData(formdata);
  }
};

  const handleMenuOpen = (event, customerId) => {
    setAnchorEl(event.currentTarget);
    setSelectedCustomerId(customerId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  //For View the =Customer data
  const handleView = (event, customer) => {
    setSelectedCustomerId(customer.id);
    setOpenViewModal(true);
    setCustomerviewData({
      ...customerviewData,
      customerId: customer["id"],
      name: customer["first_name"],
      email: customer["email"],
      phoneNumber: customer["phone_number"],
      status: customer["status"],
      dob: customer["dob"]
        ? convertYearMonthDateToMonthDateYear(customer["dob"])
        : "",
    });
  };

  const handleViewClose = () => {
    setOpenViewModal(false);
  };

  const handleProfileImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      //setCustomerData({ ...customerData, profilePhoto: URL.createObjectURL(file) });
      setCustomerData({
        ...customerData,
        profilePhoto: URL.createObjectURL(file),
      });
      setSelectedFile(file);
    }
  };

  const createRedIcon = () => {
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      return {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new window.google.maps.Size(40, 40),
      };
    }
    console.log("Google Maps not loaded yet");
    return null;
  };

  //close button
  const handleClose = () => {
    setModalOpen(false);
    setDeleteModalOpen(false);
    clearErrors();
    if (createCustomersData && createCustomersData["status"] === true) {
      initializeCustomers();
      setCustomerData({
        latitude: "",
        longitude: "",
      });
      setOpen(false);
    }
    if (isEditMode) {
      if (updateCustomersData && updateCustomersData["status"] === true) {
        initializeCustomers();
        setCustomerData({
          latitude: "",
          longitude: "",
        });
        setOpen(false);
      }
    }
    setSnackbarState({
      message: "",
      status: "",
    });
  };

  const LocationPicker = ({ setLatitude, setLongitude, setLocation }) => {
    const handleMapClick = (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address;
          setLatitude(lat);
          setLongitude(lng);
        }
      });
    };
  };

  const handleApprove = (id) => {
    setFeedbacks(
      feedbacks.map((feedback) =>
        feedback.id === id ? { ...feedback, approved: true } : feedback,
      ),
    );
  };

  const handleSort = (option) => {
    setSortOption(option);
    let filteredFeedbacks;
    const currentDate = new Date();

    if (option === "thisWeek") {
      filteredFeedbacks = feedbacks.filter((feedback) => {
        const feedbackDate = new Date(feedback.date);
        const weekAgo = new Date();
        weekAgo.setDate(currentDate.getDate() - 7);
        return feedbackDate >= weekAgo && feedbackDate <= currentDate;
      });
    } else if (option === "thisMonth") {
      filteredFeedbacks = feedbacks.filter((feedback) => {
        const feedbackDate = new Date(feedback.date);
        return (
          feedbackDate.getMonth() === currentDate.getMonth() &&
          feedbackDate.getFullYear() === currentDate.getFullYear()
        );
      });
    } else if (option === "thisYear") {
      filteredFeedbacks = feedbacks.filter((feedback) => {
        const feedbackDate = new Date(feedback.date);
        return feedbackDate.getFullYear() === currentDate.getFullYear();
      });
    } else {
      filteredFeedbacks = feedbacks;
    }

    setFeedbacks(filteredFeedbacks);
  };

  const handleResponseChange = (id, value) => {
    setFeedbacks(
      feedbacks.map((feedback) =>
        feedback.id === id ? { ...feedback, response: value } : feedback,
      ),
    );
  };

  const handleRatingChange = (id, newRating) => {
    setFeedbacks(
      feedbacks.map((feedback) =>
        feedback.id === id ? { ...feedback, rating: newRating } : feedback,
      ),
    );
  };

  const redeemHistory = [
    { orderId: "ORD123456", points: 100, date: "19 Jan 2024" },
    { orderId: "ORD789101", points: 200, date: "20 Jan 2024" },
  ];
  const {
    data: ordersApiData,
    isLoading: isOrdersLoading,
    error: ordersError,
    fetchData: fetchOrdersApi,
  } = useFetch(BASE_URL_TEST + urls("getOrderByUserId", id), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: ratingsApiData,
    isLoading: isRatingsLoading,
    error: ratingsError,
    fetchData: fetchRatings,
  } = useFetch(BASE_URL_TEST + urls("getRatings"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    fetchOrdersApi();
    fetchRatings();
  }, [filter]);

  useEffect(() => {
    if (
      ratingsApiData &&
      ratingsApiData.status === true &&
      Array.isArray(ratingsApiData.data)
    ) {
      setCustomerRatings(ratingsApiData.data);
    }
  }, [ratingsApiData]);
  const transformOrders = (data) => {
    let orders = [];

    data?.forEach((cart) => {
      cart.vendors?.forEach((vendor) => {
        vendor.items?.forEach((item) => {
          orders.push({
            id: cart.cart_number,
            name: item.product?.name,
            price: item.sellingPrice,
            payment: cart.payment_method === "CASH" ? "COD" : "Online Payment",
            date: new Date(cart.transaction_date_time).toLocaleDateString(
              "en-GB",
              {
                day: "2-digit",
                month: "short",
                year: "numeric",
              },
            ),
            status: vendor.order_status, // ✅ IMPORTANT
          });
        });
      });
    });

    return orders;
  };
  const filteredOrders = useMemo(() => {
    if (filter === "All" || filter === "Orders") return ordersTableData;

    return ordersTableData.filter(
      (order) => order.status?.toLowerCase() === filter.toLowerCase(),
    );
  }, [ordersTableData, filter]);

  const paginatedOrders = useMemo(() => {
    const startIndex = orderPage * orderRowsPerPage;
    return filteredOrders.slice(startIndex, startIndex + orderRowsPerPage);
  }, [filteredOrders, orderPage, orderRowsPerPage]);

  const selectedCustomerRatings = useMemo(() => {
    if (
      !Array.isArray(customerRatings) ||
      selectedCustomerId === null ||
      selectedCustomerId === undefined
    )
      return [];

    const customerIdAsString = String(selectedCustomerId).trim();

    return customerRatings.filter((rating) => {
      const ratingCustomerId = rating.customer_id;
      return String(ratingCustomerId).trim() === customerIdAsString;
    });
  }, [customerRatings, selectedCustomerId]);

  useEffect(() => {
    if (ordersApiData?.data) {
      setOrdersTableData(transformOrders(ordersApiData.data));
    }
  }, [ordersApiData]);

  useEffect(() => {
    setOrderPage(0);
  }, [filter, filteredOrders.length]);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const TabPanel = ({ children, value, index }) => {
    return (
      <div hidden={value !== index}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  };

  const handleDateChange = (date) => {
    setDob(date); // Update state with selected date
  };

 const handleEdit = async (customer) => {
  setEditMode(true);  // ✅ just boolean
  setOpen(true);

  setCustomerData({
    firstName: customer["first_name"] || "",
    lastName: customer["last_name"] || "",
    location: customer["location"] || "",
    email: customer["email"] || "",
    phoneNumber: customer["phone_number"] || "",
    status: customer["status"] || "",
    profilePhoto: customer["profile"] || "",
    dob: customer["dob"]
      ? convertYearMonthDateToMonthDateYear(customer["dob"])
      : null,
    country: customer["country"] || "",
    state: customer["state"] || "",
    city: customer["city"] || "",
    street: customer["street"] || "",
    landmark: customer["landmark"] || "",
    pincode: customer["pincode"] || "",
    latitude: customer["latitude"] || "",
    longitude: customer["longitude"] || "",
    searchlocation: "",
    id: customer["id"],   // ✅ make sure id is set
  });

  // reverse geocode for map
  if (customer.latitude && customer.longitude) {
    try {
      const reverseGeocodeResponse = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${customer.latitude},${customer.longitude}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`
      );
      const reverseGeocodeData = await reverseGeocodeResponse.json();
      if (reverseGeocodeData.results?.length > 0) {
        const address = reverseGeocodeData.results[0].formatted_address;
        setCustomerData((prev) => ({ ...prev, searchlocation: address }));
      }
      setTimeout(() => {
        const lat = parseFloat(customer.latitude);
        const lng = parseFloat(customer.longitude);
        if (mapRef.current) {
          mapRef.current.panTo({ lat, lng });
          mapRef.current.setZoom(15);
        }
        if (markerRef.current) {
          markerRef.current.setPosition({ lat, lng });
        }
      }, 100);
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  }
  setAnchorEl(null);
};
  const handleDelete = (customerId) => {
    const deleteUrl = urls("deleteCustomer", customerId);
    fetchDeleteData(deleteUrl);
  };

  const handlePencilModalOpen = () => {
    setOpenPencilModal(true);
  };

  const handleDownloadExcel = () => {
    if (!data || data.length === 0) {
      alert("No data available to download.");
      return;
    }

    const excelData = data.map((customer, index) => ({
      "S.No": index + 1,
      "Customer ID": customer.id || "",
      "First Name": customer.first_name || "",
      "Last Name": customer.last_name || "",
      Email: customer.email || "",
      "Phone Number": customer.phone_number || "",
      Location: customer.location || "",
      Country: customer.country || "",
      State: customer.state || "",
      City: customer.city || "",
      Street: customer.street || "",
      Landmark: customer.landmark || "",
      Pincode: customer.pincode || "",
      "Date of Birth": customer.dob
        ? convertYearMonthDateToMonthDateYear(customer.dob)
        : "",
      Status: customer.status || "",
      Latitude: customer.latitude || "",
      Longitude: customer.longitude || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Set column widths
    worksheet["!cols"] = [
      { wch: 5 }, // S.No
      { wch: 12 }, // Customer ID
      { wch: 15 }, // First Name
      { wch: 15 }, // Last Name
      { wch: 25 }, // Email
      { wch: 15 }, // Phone Number
      { wch: 20 }, // Location
      { wch: 15 }, // Country
      { wch: 15 }, // State
      { wch: 15 }, // City
      { wch: 20 }, // Street
      { wch: 20 }, // Landmark
      { wch: 10 }, // Pincode
      { wch: 15 }, // Date of Birth
      { wch: 12 }, // Status
      { wch: 15 }, // Latitude
      { wch: 15 }, // Longitude
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

    // Generate filename with current date
    const today = new Date();
    const dateStr = `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
    XLSX.writeFile(workbook, `Customer_List_${dateStr}.xlsx`);
  };

  const handlePencilModalClose = () => {
    setOpenPencilModal(false);
  };

  const handleClear = () => {
    setEditData({ ...editData, Category: [] });
  };

  const StyledPaper = styled(Paper)({
    padding: "16px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: "#fff",
  });

  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOrderPageChange = (event, newPage) => {
    setOrderPage(newPage);
  };

  const handleOrderRowsPerPageChange = (event) => {
    setOrderRowsPerPage(parseInt(event.target.value, 10));
    setOrderPage(0);
  };
  const paginatedRatings = useMemo(() => {
    const startIndex = ratingsPage * ratingsRowsPerPage;
    return selectedCustomerRatings.slice(
      startIndex,
      startIndex + ratingsRowsPerPage,
    );
  }, [selectedCustomerRatings, ratingsPage, ratingsRowsPerPage]);
  useEffect(() => {
    setRatingsPage(0);
  }, [selectedCustomerId]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        p: 2,
        bgcolor: "#EEF2FF",
      }}
    >
      <AppHeaderBar
        title={"Customer Management"}
        onBackScreenName={handleScreeName}
      />
      <Box sx={{ p: 3, backgroundColor: "#F9FAFC" }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          style={{ marginBottom: "30px" }}
        >
          <Grid item>
            <TextField
              label="Search"
              variant="outlined"
              size="small"
              value={search}
              onChange={handleSearch}
            />
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={handleDownloadExcel}
              disabled={!data || data.length === 0}
            >
              Download Excel
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              style={{ marginLeft: "10px" }}
              onClick={handleAdd}
            >
              Add Customer
            </Button>
          </Grid>
        </Grid>

        <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
              <TableRow>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  CustomerID
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Name
                </TableCell>

                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Location
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Email
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Phone
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Actions
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  View
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography>No records found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((customer) => {
                    return (
                      <TableRow key={customer.id}>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {customer.id}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          <Box
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {customer.first_name}
                          </Box>
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {customer.location}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {customer.email}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {customer.phone_number}
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            color:
                              customer.status === "Pause"
                                ? "orange"
                                : customer.status === "Active"
                                  ? "green"
                                  : customer.status === "In Active"
                                    ? "red"
                                    : "black", // Default color for other statuses
                            fontWeight: "bold", // Optional: Makes the text bold
                          }}
                        >
                          {customer.status}
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          <IconButton
                            onClick={(e) => handleMenuOpen(e, customer.id)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            anchorEl={anchorEl}
                            open={
                              Boolean(anchorEl) &&
                              selectedCustomerId === customer.id
                            }
                            onClose={handleMenuClose}
                          >
                            <MenuItem onClick={() => handleEdit(customer)}>
                              <EditIcon /> Edit
                            </MenuItem>
                            {/* <MenuItem onClick={() => handleDelete(customer.id)}>
                              <DeleteIcon /> Delete
                            </MenuItem> */}
                          </Menu>
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          <IconButton
                            color="primary"
                            onClick={(e) => handleView(e, customer)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 50, 100, 150]}
          component="div"
          count={data && data.length ? data.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
        <Dialog
          open={isDeleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
        >
          <DialogTitle>
            {snackbarState.status === true ? "Success" : "Error"}
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              sx={{
                color: snackbarState.status === true ? "green" : "red",
              }}
            >
              {snackbarState.message}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                alignSelf: "center",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal for Add/Edit */}
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)", // Center the modal
              width: "90vw",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 3,
              overflowY: "scroll", // Enable vertical scrolling
              borderRadius: 2, // Rounded corners
              "&::-webkit-scrollbar": {
                display: "none", // Hide scrollbar for Webkit browsers
              },
              "-ms-overflow-style": "none", // Hide scrollbar for Internet Explorer and Edge
              "scrollbar-width": "none", // Hide scrollbar for Firefox
            }}
          >
            <Box sx={{ position: "relative" }}>
              <h2 id="modal-title">
               {isEditMode ? "Edit Customer" : "Add Customer"}
              </h2>
              <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <TextField
                autoFocus
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                value={customerData?.firstName || ""}
                onChange={(e) =>
                  setCustomerData({
                    ...customerData,
                    firstName: e.target.value,
                  })
                }
                error={!!errors.firstName}
                helperText={
                  errors.firstName && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.firstName}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="Last Name"
                type="text"
                fullWidth
                value={customerData?.lastName || ""}
                onChange={(e) =>
                  setCustomerData({ ...customerData, lastName: e.target.value })
                }
              />

              <TextField
                margin="dense"
                label="Email"
                type="email"
                fullWidth
                value={customerData?.email || ""}
                onChange={(e) =>
                  setCustomerData({ ...customerData, email: e.target.value })
                }
                error={!!errors.email}
                helperText={
                  errors.email && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.email}
                    </Typography>
                  )
                }
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Box sx={{ flex: 1 }}>
                <TextField
                  margin="dense"
                  label="Phone"
                  type="tel"
                  fullWidth
                  value={customerData?.phoneNumber || ""}
                  onChange={(e) =>
                    setCustomerData({
                      ...customerData,
                      phoneNumber: e.target.value,
                    })
                  }
                  error={!!errors.phoneNumber}
                  helperText={
                    errors.phoneNumber && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.phoneNumber}
                      </Typography>
                    )
                  }
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TextField
                  margin="dense"
                  label="Location"
                  type="text"
                  fullWidth
                  value={customerData?.location || ""}
                  onChange={(e) =>
                    setCustomerData({
                      ...customerData,
                      location: e.target.value,
                    })
                  }
                  error={!!errors.location}
                  helperText={
                    errors.location && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.location}
                      </Typography>
                    )
                  }
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Date of Birth"
                    value={customerData.dob ? new Date(customerData.dob) : null}
                    maxDate={new Date()}
                    onChange={(newValue) => {
                      setCustomerData({ ...customerData, dob: newValue });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth sx={{ mb: 4 }} />
                    )}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
            <Grid container spacing={2} sx={{ mb: 4 }} alignItems="center">
              <Grid item xs={12} sm={3}>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: "bold" }}>
                  Profile photo
                </Typography>
                <Avatar
                  alt="Profile"
                  src={customerData?.profilePhoto || "/default-profile.png"}
                  sx={{
                    width: 100,
                    height: 100,
                    border: "2px solid #ddd",
                    mb: 1,
                  }}
                />
                <Typography variant="body2" color="textSecondary" marginTop={1}>
                  Image should be in 300 X 300.(size:40kb)
                </Typography>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Button
                  variant="contained"
                  component="label"
                  startIcon={<UploadFile />}
                  sx={{
                    mr: 2,
                    bgcolor: "#3f51b5",
                    "&:hover": { bgcolor: "#303f9f" },
                  }}
                >
                  Upload Image
                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    onChange={handleProfileImage}
                  />
                </Button>

                <Button
                  variant="outlined"
                  startIcon={<Delete />}
                  onClick={() => {
                    setCustomerData((prevData) => ({
                      ...prevData,
                      profilePhoto: "",
                    }));
                  }}
                  sx={{
                    color: "#f44336",
                    borderColor: "#f44336",
                    "&:hover": { bgcolor: "#ffe6e6" },
                  }}
                >
                  Delete
                </Button>
              </Grid>
            </Grid>

            <Box
              sx={{
                display: "flex",
                gap: "20px",
                marginBottom: "20px",
                mt: 2,
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ flex: 2, mt: 2 }}></Box>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography variant="h6">Address</Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                margin="dense"
                label="Country"
                type="tel"
                fullWidth
                value={customerData?.country || ""}
                onChange={(e) =>
                  setCustomerData({ ...customerData, country: e.target.value })
                }
                error={!!errors.country}
                helperText={
                  errors.country && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.country}
                    </Typography>
                  )
                }
              />

              <TextField
                margin="dense"
                label="State"
                type="tel"
                fullWidth
                value={customerData?.state || ""}
                onChange={(e) =>
                  setCustomerData({ ...customerData, state: e.target.value })
                }
                error={!!errors.state}
                helperText={
                  errors.state && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.state}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="City"
                type="tel"
                fullWidth
                value={customerData?.location || ""}
                onChange={(e) =>
                setCustomerData({ ...customerData, location: e.target.value })
                }
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                margin="dense"
                label="Street"
                type="tel"
                fullWidth
                value={customerData?.street || ""}
                onChange={(e) =>
                  setCustomerData({ ...customerData, street: e.target.value })
                }
                error={!!errors.street}
                helperText={
                  errors.street && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.street}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="Land mark"
                type="tel"
                fullWidth
                value={customerData?.landmark || ""}
                onChange={(e) =>
                  setCustomerData({ ...customerData, landmark: e.target.value })
                }
                error={!!errors.landmark}
                helperText={
                  errors.landmark && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.landmark}
                    </Typography>
                  )
                }
              />

              <TextField
                margin="dense"
                label="Pin code"
                type="tel"
                fullWidth
                value={customerData?.pincode || ""}
                onChange={(e) =>
                  setCustomerData({ ...customerData, pincode: e.target.value })
                }
                error={!!errors.pincode}
                helperText={
                  errors.pincode && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.pincode}
                    </Typography>
                  )
                }
              />
            </Box>

            <Box sx={{}}>
              <Typography variant="h6">Select Location</Typography>

              {/* Search Box */}
              <TextField
                fullWidth
                margin="dense"
                label="Search Location"
                variant="outlined"
                sx={{ mt: 2 }}
                value={customerData?.searchlocation}
                onChange={handleLocationSearch}
                error={!!errors.searchlocation}
                helperText={
                  errors.searchlocation && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.searchlocation}
                    </Typography>
                  )
                }
              />

              {/* Map Container */}
              <Box sx={{ padding: 3 }}>
                <GoogleMap
                  ref={mapRef}
                  onLoad={(map) => {
                    mapRef.current = map;
                    if (customerData.latitude && customerData.longitude) {
                      map.panTo({
                        lat: parseFloat(customerData.latitude),
                        lng: parseFloat(customerData.longitude),
                      });
                      map.setZoom(15);
                    }
                  }}
                  center={{
                    lat: parseFloat(customerData.latitude) || 0,
                    lng: parseFloat(customerData.longitude) || 0,
                  }}
                  zoom={13}
                  mapContainerStyle={{
                    height: "400px",
                    width: "100%",
                    marginTop: "20px",
                  }}
                  options={{
                    streetViewControl: false,
                    mapTypeControl: false,
                  }}
                  // ✅ Click anywhere on map to move marker
                  onClick={(e) => {
                    const lat = e.latLng.lat();
                    const lng = e.latLng.lng();
                    setCustomerData((prevData) => ({
                      ...prevData,
                      latitude: lat,
                      longitude: lng,
                    }));
                  }}
                >
                  {customerData.latitude && customerData.longitude && (
                    <MarkerF
                      ref={markerRef}
                      position={{
                        lat: parseFloat(customerData.latitude),
                        lng: parseFloat(customerData.longitude),
                      }}
                      icon={createRedIcon()}
                      draggable={true} // ✅ Allow dragging
                      // ✅ Update position when dragged
                      onDragEnd={(e) => {
                        const lat = e.latLng.lat();
                        const lng = e.latLng.lng();
                        setCustomerData((prevData) => ({
                          ...prevData,
                          latitude: lat,
                          longitude: lng,
                        }));
                      }}
                      onClick={() => setInfoWindowOpen(true)}
                    >
                      {isInfoWindowOpen && (
                        <InfoWindowF
                          position={{
                            lat: parseFloat(customerData.latitude),
                            lng: parseFloat(customerData.longitude),
                          }}
                          onCloseClick={() => setInfoWindowOpen(false)}
                        >
                          <div>
                            <p>
                              Latitude: {customerData.latitude}, Longitude:{" "}
                              {customerData.longitude}
                            </p>
                          </div>
                        </InfoWindowF>
                      )}
                    </MarkerF>
                  )}
                </GoogleMap>
              </Box>

              {/* Latitude and Longitude Text Fields */}
              <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                <TextField
                  margin="dense"
                  label="Latitude"
                  type="text"
                  fullWidth
                  value={customerData?.latitude}
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <TextField
                  margin="dense"
                  label="Longitude"
                  type="text"
                  fullWidth
                  value={customerData?.longitude || ""}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Box>
            </Box>
            <Box>
              {/* <FormControl fullWidth margin="dense">
                <InputLabel id="status-label">Status</InputLabel>
                <Select
                  labelId="status-label"
                  id="status-select"
                  value={customerData?.status || ""}
                  error={!!errors.statusDropdown}
                  onChange={(e) =>
                    setCustomerData({
                      ...customerData,
                      status: e.target.value,
                    })
                  }
                  label="Status"
                >
                  {moduleStatusData &&
                  typeof moduleStatusData.options === "string" ? (
                    moduleStatusData.options.split(",").map((option, index) => (
                      <MenuItem key={index} value={option.trim()}>
                        {option.trim()}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No status data available</MenuItem>
                  )}
                </Select>
                {errors.statusDropdown && (
                  <helperText>
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.statusDropdown}
                    </Typography>
                  </helperText>
                )}
              </FormControl> */}

              <FormControl fullWidth margin="dense">
                <InputLabel id="status-label">Status</InputLabel>

                <Select
                  labelId="status-label"
                  id="status-select"
                  value={customerData?.status || ""}
                  error={!!errors.statusDropdown}
                  onChange={(e) =>
                    setCustomerData({
                      ...customerData,
                      status: e.target.value,
                    })
                  }
                  label="Status"
                >
                  {["active", "stopped"].map((status, index) => (
                    <MenuItem key={index} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>

                {errors.statusDropdown && (
                  <Typography
                    sx={{
                      textAlign: "left",
                      marginTop: 1,
                      color: "red",
                      fontSize: 12,
                    }}
                  >
                    {errors.statusDropdown}
                  </Typography>
                )}
              </FormControl>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                onClick={() => setOpen(false)}
                sx={{ marginRight: 2, color: "white", backgroundColor: "red" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSubmit}
                sx={{ color: "white", backgroundColor: "green" }}
              >
                {isEditMode ? "Update" : "Add"}
              </Button>
            </Box>
          </Box>
        </Modal>
        <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
          <DialogTitle>
            {snackbarState.status === true ? "Success" : "Error"}
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              sx={{
                color: snackbarState.status === true ? "green" : "red",
              }}
            >
              {snackbarState.message}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                alignSelf: "center",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* Modal for View Icon */}
        <Modal
          open={openViewModal}
          onClose={handleViewClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)", // Center the modal
              width: "80vw",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 3,
              overflowY: "scroll", // Enable vertical scrolling
              borderRadius: 2, // Rounded corners
              "&::-webkit-scrollbar": {
                display: "none", // Hide scrollbar for Webkit browsers
              },
              "-ms-overflow-style": "none", // Hide scrollbar for Internet Explorer and Edge
              "scrollbar-width": "none", // Hide scrollbar for Firefox
            }}
          >
            <Box sx={{ position: "relative" }}>
              <h2 id="modal-title">
                {customerData?.id ? "Edit Customer" : "View Customer"}
              </h2>
              <IconButton
                aria-label="close"
                onClick={handleViewClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box sx={{ width: "100%", padding: 2 }}>
              <Tabs value={tabValue} onChange={handleTabChange} centered>
                <Tab label="Profile" />
                <Tab label="Order History" />
                {/* <Tab label="Rewards Points" /> */}
                <Tab label="Rating and reviews" />
              </Tabs>

              <TabPanel value={tabValue} index={0}>
                <Box
                  sx={{
                    // maxWidth: 800,
                    margin: "auto",
                    padding: 4,
                    boxShadow: 1,
                    borderRadius: 2,
                    backgroundColor: "#fff",
                  }}
                >
                  {/* Profile Header */}
                  <Box display="flex" alignItems="center" marginBottom={4}>
                    <Box
                      sx={{
                        width: 64,
                        height: 64,
                        borderRadius: "50%",
                        backgroundColor: "#ddd",
                        marginRight: 2,
                      }}
                    />
                    <Box>
                      <Typography variant="h6" fontWeight="bold">
                        {customerviewData?.name}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {customerviewData?.email}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Form Fields */}
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Customer ID"
                        fullWidth
                        value={customerviewData?.customerId}
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Phone"
                        fullWidth
                        value={customerviewData?.phoneNumber}
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label="Email"
                        fullWidth
                        value={customerviewData?.email}
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label="Status"
                        value={customerviewData?.status}
                        fullWidth
                        InputProps={{
                          readOnly: true,
                          sx: {
                            color: "green",
                            fontWeight: "bold",
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label="DOB"
                        value={customerviewData?.dob}
                        fullWidth
                        InputProps={{
                          readOnly: true,
                          sx: {
                            color: "green",
                            fontWeight: "bold",
                          },
                        }}
                      />
                    </Grid>

                    {/* <Grid item xs={6}>
                      <TextField
                        label="Total Orders"
                        value="12"
                        fullWidth
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Total Spent"
                        value="12000/-"
                        fullWidth
                        InputProps={{ readOnly: true }}
                      />
                    </Grid> */}
                  </Grid>

                  {/* View All Orders Link */}
                  {/* <Box marginTop={2}>
                    <Button variant="text" color="primary">
                      View all orders
                    </Button>
                  </Box> */}
                </Box>
              </TabPanel>

              <TabPanel value={tabValue} index={1}>
                <Paper elevation={3} sx={{ padding: 2, borderRadius: "20px" }}>
                  <Box
                    sx={{
                      padding: 2,
                      // backgroundColor: "#f9f9f9",
                      // minHeight: "100vh",
                    }}
                  >
                    {/* Dropdown for filtering */}
                    <Box
                      sx={{
                        marginBottom: 2,
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Select
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        displayEmpty
                        variant="outlined"
                        sx={{ width: 200, backgroundColor: "#fff" }}
                      >
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="Shipped">Shipped</MenuItem>
                        <MenuItem value="Delivered">Delivered</MenuItem>
                        <MenuItem value="Canceled">Canceled</MenuItem>
                        <MenuItem value="Returned/Refund">
                          Returned/Refund
                        </MenuItem>
                      </Select>
                    </Box>

                    {/* Orders UI */}
                    <TableContainer
                      component={Paper}
                      sx={{ borderRadius: "20px" }}
                    >
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Order ID</TableCell>
                            <TableCell>Product</TableCell>
                            <TableCell>Price</TableCell>
                            <TableCell>Payment</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Date</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {paginatedOrders.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={6} align="center">
                                No orders found for "{filter}"
                              </TableCell>
                            </TableRow>
                          ) : (
                            paginatedOrders.map((order, index) => (
                              <TableRow key={`${order.id}-${index}`}>
                                <TableCell>{order.id}</TableCell>
                                <TableCell>{order.name}</TableCell>
                                <TableCell>₹{order.price}</TableCell>
                                <TableCell>{order.payment}</TableCell>
                                <TableCell
                                  sx={{
                                    color:
                                      order.status === "DELIVERED"
                                        ? "green"
                                        : order.status === "PENDING"
                                          ? "orange"
                                          : order.status === "Canceled" ||
                                              order.status === "Canceled/Refund"
                                            ? "red"
                                            : "black",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {order.status}
                                </TableCell>
                                <TableCell>{order.date}</TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        component="div"
                        count={filteredOrders.length}
                        rowsPerPage={orderRowsPerPage}
                        page={orderPage}
                        onPageChange={handleOrderPageChange}
                        onRowsPerPageChange={handleOrderRowsPerPageChange}
                      />
                    </TableContainer>
                  </Box>
                </Paper>
              </TabPanel>

              <TabPanel value={tabValue} index={2}>
                <Paper elevation={3} sx={{ padding: 2, borderRadius: "20px" }}>
                  <Box sx={{ p: 2 }}>
                    <Typography variant="h4" gutterBottom>
                      Customer Feedback
                    </Typography>

                    {selectedCustomerRatings.length === 0 ? (
                      <Typography
                        variant="body2"
                        sx={{ mt: 2, textAlign: "center" }}
                      >
                        No ratings available for this customer.
                      </Typography>
                    ) : (
                      <>
                        {paginatedRatings.map((rating) => (
                          <Card
                            key={rating.rating_id}
                            sx={{
                              mb: 2,
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                            }}
                          >
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  mb: 1,
                                }}
                              >
                                <Typography variant="subtitle1">
                                  Product: {rating.product?.name || "N/A"}
                                </Typography>
                                <Typography variant="subtitle2">
                                  {new Date(
                                    rating.createdAt,
                                  ).toLocaleDateString()}
                                </Typography>
                              </Box>

                              <Typography
                                variant="body1"
                                sx={{ fontWeight: "bold", mb: 1 }}
                              >
                                Rating: {rating.rating}
                              </Typography>

                              <Rating
                                value={rating.rating}
                                readOnly
                                sx={{ mb: 1 }}
                              />

                              <Typography
                                variant="body2"
                                sx={{ color: "#555" }}
                              >
                                {rating.description ||
                                  "No description provided."}
                              </Typography>

                              <Typography
                                variant="body2"
                                sx={{ color: "#888", mt: 1 }}
                              >
                                Vendor:{" "}
                                {rating.vendor?.shop_name ||
                                  rating.vendor?.name ||
                                  "N/A"}
                              </Typography>
                            </CardContent>
                          </Card>
                        ))}

                        {/* Pagination */}
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          component="div"
                          count={selectedCustomerRatings.length}
                          rowsPerPage={ratingsRowsPerPage}
                          page={ratingsPage}
                          onPageChange={(event, newPage) =>
                            setRatingsPage(newPage)
                          }
                          onRowsPerPageChange={(event) => {
                            setRatingsRowsPerPage(
                              parseInt(event.target.value, 10),
                            );
                            setRatingsPage(0);
                          }}
                        />
                      </>
                    )}
                  </Box>
                </Paper>
              </TabPanel>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={handleViewClose}
                sx={{ color: "white", backgroundColor: "red" }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
};

export default AdminCustomerManagement;
